module.exports = __webpack_public_path__ + "static/media/logo-lak-thueringen.0ddffea5.png";